import { createDirectus, authentication, rest } from "@directus/sdk";

const directusUrl = process.env.REACT_APP_DIRECTUS_URL;

if (!directusUrl) {
  throw new Error("Missing REACT_APP_DIRECTUS_URL environment variable");
}

const client = createDirectus(directusUrl)
  .with(authentication("session", { credentials: "include" }))
  .with(rest({ credentials: 'include' }));

async function getClient() {
  return client;
}

export default getClient;